"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const synonym_1 = __importDefault(require("@app/routes/SpeechDevelopment/synonym"));
const exerciseByCheckOrderButton_1 = __importDefault(require("@app/routes/SpeechDevelopment/exerciseByCheckOrderButton"));
const _params_1 = require("@params");
const prepositions_1 = __importDefault(require("@app/routes/SpeechDevelopment/prepositions"));
const disinhibition_1 = __importDefault(require("@app/routes/SpeechDevelopment/disinhibition"));
const text_7_5_1 = __importDefault(require("@app/routes/SpeechDevelopment/text_7_5"));
const text_7_2_1 = __importDefault(require("@app/routes/SpeechDevelopment/text_7_2"));
const completeSentence_1 = __importDefault(require("@app/routes/SpeechDevelopment/completeSentence"));
const common_1 = require("@components/common");
const styled_components_1 = __importDefault(require("styled-components"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const fakeDisinhibition_1 = __importDefault(require("@app/routes/SpeechDevelopment/disinhibition/fakeDisinhibition"));
const Description = styled_components_1.default.div `
    font-family: "GolosTextWebRegular", sans-serif;
    color: #6e77fb;
    font-size: 18px;
    padding: 15px;
    text-align: center;
    line-height: 27px;
    font-weight: 500;
    white-space: break-spaces;
    text-transform: uppercase;
`;
function isSingleWord(offer) {
    var _a;
    const w = offer.right_word.trim();
    const content = (_a = offer === null || offer === void 0 ? void 0 : offer.content) === null || _a === void 0 ? void 0 : _a.trim();
    return !/\s/.test(w) && content === '*';
}
const SpeechDevelopment = () => {
    const [componentType, setComponentType] = (0, react_1.useState)('');
    const [response, setResponse] = (0, react_1.useState)(null);
    const [description, setDescription] = (0, react_1.useState)('');
    const [open, setOpen] = (0, react_1.useState)(false);
    const langId = js_cookie_1.default.get("lang_id");
    (0, react_1.useEffect)(() => {
        const rootElement = document.getElementById('ezspeech-react-front');
        const shortDescription = (rootElement === null || rootElement === void 0 ? void 0 : rootElement.getAttribute('data-short-description')) || '';
        setDescription(shortDescription);
    }, []);
    (0, react_1.useEffect)(() => {
        const pathName = window.location.pathname;
        const url = new URL(pathName, window.location.origin);
        const slug = url.pathname.split('/').pop();
        fetch(`${_params_1.apiHost}/exercises/speech/${slug}`).then(res => res.json()).then(response => {
            setOpen(true);
            setResponse(response);
            setComponentType(response.text.text_type);
        });
    }, []);
    const ComponentsByType = (0, react_1.useMemo)(() => {
        var _a, _b;
        const timer = ['naidi_svyaz_10', 'naidi_svyaz_11'].includes(response === null || response === void 0 ? void 0 : response.slug)
            ? 60000
            : 0;
        // 1. Extract complex condition for readability
        const shouldUseFakeDisinhibition = componentType === 'disinhibition' &&
            +langId === 2 &&
            ((_b = (_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.offers) === null || _b === void 0 ? void 0 : _b.every(el => isSingleWord(el)));
        const components = {
            '7.1': react_1.default.createElement(text_7_5_1.default, { response: response, description: description, langId: langId }),
            'voice': react_1.default.createElement(text_7_2_1.default, { response: response, description: description, langId: langId }),
            '7.3': react_1.default.createElement(completeSentence_1.default, { response: response, description: description, langId: langId }),
            synonym: react_1.default.createElement(synonym_1.default, { response: response, description: description, langId: langId }),
            '7.5': react_1.default.createElement(exerciseByCheckOrderButton_1.default, { response: response, description: description, langId: langId }),
            disinhibition: shouldUseFakeDisinhibition || (response === null || response === void 0 ? void 0 : response.slug) === 'Mixed_Topic_Quiz'
                ? react_1.default.createElement(fakeDisinhibition_1.default, { response: response, description: description, langId: langId })
                : react_1.default.createElement(disinhibition_1.default, { response: response, description: description, timer: timer, langId: langId }),
            prepositions: react_1.default.createElement(prepositions_1.default, { response: response, description: description, langId: langId }),
        };
        return components[componentType];
    }, [
        // 2. Include ALL dependencies
        componentType,
        response,
        langId,
        description,
        isSingleWord, // Required if defined outside component
    ]);
    (0, react_1.useEffect)(() => {
        if (open) {
            const handleClickOutside = () => setOpen(false);
            document.addEventListener("click", handleClickOutside);
            return () => {
                document.removeEventListener("click", handleClickOutside);
            };
        }
    }, [open, setOpen]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(common_1.PopUp, { title: `${Number(langId) === 1 ? "Развитие речи" : "Speech development"}`, onClose: () => setOpen(false), open: open, isUseStopPropogation: false, description: description },
            react_1.default.createElement(Description, null, description)),
        ComponentsByType));
};
exports.default = SpeechDevelopment;
